import { render, staticRenderFns } from "./ArchiveLessonItem.vue?vue&type=template&id=7474a258&scoped=true"
import script from "./ArchiveLessonItem.vue?vue&type=script&lang=ts"
export * from "./ArchiveLessonItem.vue?vue&type=script&lang=ts"
import style0 from "./ArchiveLessonItem.vue?vue&type=style&index=0&id=7474a258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7474a258",
  null
  
)

export default component.exports